module.exports = __webpack_public_path__ + "static/media/product-arrow-right.050adfb2.svg";